(() => {
  if (window.hkRecommendationProductsReady) return;
  window.hkRecommendationProductsReady = true;

  const SELECTOR = '[data-hk-recommendations]';
  const CACHE_TTL = 5 * 60 * 1000;

  const readCache = (key) => {
    if (window.Shopify?.designMode) return null;

    try {
      const cached = JSON.parse(sessionStorage.getItem(key));
      if (!cached?.html || Date.now() - cached.savedAt > CACHE_TTL) return null;
      return cached.html;
    } catch {
      return null;
    }
  };

  const writeCache = (key, html) => {
    if (window.Shopify?.designMode) return;

    try {
      sessionStorage.setItem(key, JSON.stringify({ html, savedAt: Date.now() }));
    } catch {}
  };

  const replaceGrid = (root, html) => {
    const grid = root.querySelector('[data-hkrp-grid]');
    if (!grid || !html) return false;

    const template = document.createElement('template');
    template.innerHTML = html;
    const cards = template.content.querySelectorAll('.hkrp-card');
    if (cards.length !== 4) return false;

    grid.dataset.hkrpHydrated = 'true';
    grid.replaceChildren(template.content.cloneNode(true));
    root.dataset.hkrpPersonalized = 'true';
    return true;
  };

  const fetchRecommendations = async (root) => {
    if (root.dataset.hkrpPersonalized === 'true' || root.dataset.hkrpRequestStarted === 'true') return;

    const { hkrpUrl, hkrpProductId, hkrpSectionId } = root.dataset;
    if (!hkrpUrl || !hkrpProductId || !hkrpSectionId) return;

    root.dataset.hkrpRequestStarted = 'true';
    const cacheKey = `hkrp:v2:${hkrpProductId}:${hkrpSectionId}`;
    const cachedGrid = readCache(cacheKey);
    if (cachedGrid && replaceGrid(root, cachedGrid)) return;

    const url = new URL(hkrpUrl, window.location.origin);
    url.searchParams.set('limit', '4');
    url.searchParams.set('product_id', hkrpProductId);
    url.searchParams.set('section_id', hkrpSectionId);
    url.searchParams.set('intent', 'related');

    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 8000);

    try {
      const response = await fetch(url, {
        credentials: 'same-origin',
        signal: controller.signal,
        priority: 'high',
      });
      if (!response.ok) return;

      const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
      const responseRoot = responseDocument.getElementById(`HKRecommendations-${hkrpSectionId}`);
      const responseGrid = responseRoot?.querySelector('[data-hkrp-grid]');
      if (!responseGrid || responseGrid.querySelectorAll('.hkrp-card').length !== 4) return;

      const personalizedHtml = responseGrid.innerHTML;
      writeCache(cacheKey, personalizedHtml);
      replaceGrid(root, personalizedHtml);
    } catch (error) {
      if (error.name !== 'AbortError') console.warn('Recommended products could not be refreshed.', error);
    } finally {
      window.clearTimeout(timeout);
    }
  };

  const initialize = (scope = document) => {
    if (scope.matches?.(SELECTOR)) fetchRecommendations(scope);
    scope.querySelectorAll?.(SELECTOR).forEach(fetchRecommendations);
  };

  const openCartDrawer = () => {
    const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (!trigger || trigger.getAttribute('aria-expanded') === 'true') return;
    trigger.click();
  };

  document.addEventListener('shopify:cart:lines-update', (event) => {
    const source = event.target instanceof Element ? event.target.closest('[data-hk-recommendations] .hkrp-card') : null;
    if (!source || event.action !== 'add') return;

    if (event.promise) {
      event.promise
        .then(({ detail }) => {
          if (!detail?.didError) window.setTimeout(openCartDrawer, 120);
        })
        .catch(() => {});
      return;
    }

    window.setTimeout(openCartDrawer, 120);
  });

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
